document.addEventListener('DOMContentLoaded', () => {
  for (const el of document.querySelectorAll('.luggage-drop-hero__media')) {
    el.addEventListener('click', () => {
      const target = document.querySelector('.luggage-drop-product');
      target?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }
});
